import { Alert, Stack, TextField } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { LeadershipBlockContent } from '@/types/database';

export function LeadershipBlockEditPanel({
  content,
  onUpdate,
}: {
  content: LeadershipBlockContent;
  onUpdate: (content: LeadershipBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content, onUpdate);

  return (
    <Stack spacing={2}>
      <Alert severity="info">
        This list is pulled automatically from your unit&apos;s current leadership positions — it updates on its own when a position
        changes hands. Manage positions in Scouting Ops.
      </Alert>
      <TextField
        label="Heading"
        value={draft.heading ?? ''}
        onChange={(event) => update({ ...draft, heading: event.target.value || undefined })}
        fullWidth
      />
    </Stack>
  );
}
